module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarXD-2@2x.9d6774bc.png";